// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2YXxK","colMin":"styles_colMin__28UY3","colCheckbox":"styles_colCheckbox__1W2V-"};